import { html, type Html, Page, View } from 'rune-ts';
import klass from './CurationFeed.module.scss';
import { updateUrlParams } from '@services/MarppleShop/shared/util';
import { CardCurationView } from '@services/MarppleShop/renderApp/pages/Curation/components/CardCurationView.ts';
import { LayoutView } from '@services/MarppleShop/renderApp/components/cells/Layout/LayoutView.ts';
import { footer_links } from '@services/MarppleShop/renderApp/components/cells/Footer/constant.ts';
import { CurationListItem } from '@services/MarppleShop/features/Curation/type';
import { ProductCardViewData } from '@services/MarppleShop/features/ProductList/type';
import { BaseLayoutOptions } from '@services/MarppleShop/features/Core/service';
import {
  Pagination,
  PaginationChangeEvent,
} from '@services/MarppleShop/renderApp/components/cells/Pagination/Pagination.ts';
import { makeMainUrl } from '@services/MarppleShop/shared/util/url.ts';

const PAGINATION_SIZE = 5;

export type CurationFeedPageData = {
  recent_product: ProductCardViewData | undefined;
  layout_options: BaseLayoutOptions;
  curations: CurationListItem[];
  current_page: number;
  total_page: number;
};

class BodyView extends View<CurationFeedPageData> {
  protected override template({ curations, current_page, total_page }: CurationFeedPageData) {
    return html`<main class="${klass.section}">
      ${curations.map(
        (curation) =>
          html`<article class="${klass.card_curation_wrapper}">
            ${new CardCurationView({
              ...curation,
              device: 'Mobile',
              layout: 'Detail',
              curationDetailUrl: makeMainUrl(`/@/curations/${curation.id}?from_page=curation-feed`),
            })}
          </article>`,
      )}
      ${total_page > 1
        ? new Pagination({
            page: current_page,
            size: PAGINATION_SIZE,
            total: total_page,
          })
        : null}
    </main>`;
  }
}

export class CurationFeedPage extends Page<CurationFeedPageData> {
  protected override template(data: CurationFeedPageData): Html {
    const { layout_options } = data;
    const { is_mobile } = layout_options;

    return html`
      <div>
        ${new LayoutView(
          {
            body: new BodyView(data),
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            full_width: layout_options.is_mobile,
            ...layout_options,
            selected_bottom_tab_idx: 0,
            has_bottom_tab_bar: false,
          },
        )}
      </div>
    `;
  }

  override onMount() {
    super.onMount();

    this.delegate(PaginationChangeEvent, Pagination, function handleChangePage(e) {
      location.href = updateUrlParams(location.href, { page: e.detail.page });
    });
  }
}
